import { makeCurrentAccountHttpClientDecorator } from '@/javascript/main/factories/decorators'
import { makeApiUrl } from '../http'
import { RemoteLoadResourcePlaceById } from '@/javascript/data/usecases/remote-load-resource-place-by-id'
import { RemoteLoadResourcePlaceListByIds } from '@/javascript/data/usecases/remote-load-resource-place-list-by-ids'

export const makeRemoteLoadResourcePlaceById = () =>
  new RemoteLoadResourcePlaceById(makeApiUrl('/resource_places'), makeCurrentAccountHttpClientDecorator())

export const makeRemoteLoadResourcePlaceListByIds = () =>
  new RemoteLoadResourcePlaceListByIds(makeApiUrl('/resource_places'), makeCurrentAccountHttpClientDecorator())
